import LinkBridgeSuccess from "components/LinkBridgeSuccess";

const Connected = (props: any) => {
  const { selectedFbAccount, adminDetails } = props;

  const viewAssetsHref =
    adminDetails?.businessManagerId && selectedFbAccount?.business?.id
      ? `https://business.facebook.com/settings/partners/${adminDetails.businessManagerId}?business_id=${selectedFbAccount.business.id}`
      : undefined;

  return (
    <LinkBridgeSuccess
      platform="meta"
      accountName={selectedFbAccount?.name}
      accountId={
        selectedFbAccount?.id ? String(selectedFbAccount.id) : undefined
      }
      managerName={adminDetails?.businessManagerName}
      managerId={
        adminDetails?.businessManagerId
          ? String(adminDetails.businessManagerId)
          : undefined
      }
      viewAssetsHref={viewAssetsHref}
    />
  );
};

export default Connected;
